import type { ComponentType, PropsWithChildren } from 'react';
import { memo } from 'react';
import type { ScaleFadeProps } from '@chakra-ui/react';
import { ScaleFade as ChakraScaleFade } from '@chakra-ui/react';

export const ScaleFade = memo(ChakraScaleFade as ComponentType<PropsWithChildren<ScaleFadeProps>>);
